import styled from 'styled-components';
import { OLAF, KOALA, SLINKY } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import AcademyInfoFooter from './AcademyInfoFooter';
import CertificateImage from './CertificateImage';
import CurriculumInfo from './CurriculumInfo';
import FooterCTA from './FooterCTA';
import ColorCirclesHeader from '../../../components/ColorCirclesHeader';
import AchievementNotFound from './AchievementNotFound';
import AchievementUserProfile from './AchievementUserProfile';
import CertificateHeader from './CertificateHeader';
import { getBrochureRoot, usePublicAchievement } from '../';
import { NavMarker } from 'react-rhumb';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useEffect } from 'react';
import PrerenderGlobals from './PrerenderGlobals';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertImageWrapper = styled(CertificateImage).withConfig({
  displayName: "SingleCertAchievement__CertImageWrapper",
  componentId: "sc-3jqzo2-0"
})(["margin-top:-30px;box-shadow:1px 2px 10px 1px rgba(0,0,0,0.2);@media (min-width:", "){margin-bottom:-30px;}"], GRID_BREAKPOINT_MEDIUM);
const FooterBar = styled.div.withConfig({
  displayName: "SingleCertAchievement__FooterBar",
  componentId: "sc-3jqzo2-1"
})(["background-color:", ";&.expand-down::before{content:'';position:absolute;top:0;height:100vh;width:100vw;background-color:", ";z-index:-1;}"], props => props.bgColor, props => props.bgColor);
export const SingleCertAchievement = ({
  inModal,
  trackEvent,
  publicId,
  language
}) => {
  const {
    publicAchievementLoading,
    publicAchievementError
  } = usePublicAchievement(publicId);
  const brochureRoot = getBrochureRoot(language);
  useEffect(() => trackEvent({
    action: 'view-achievement'
  }), [trackEvent]);
  if (publicAchievementLoading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "m-y-12",
      grow: true
    });
  }
  if (publicAchievementError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "ACHIEVEMENT_MISSING",
      children: /*#__PURE__*/_jsx(AchievementNotFound, {
        brochureRoot: brochureRoot,
        language: language
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "achievement-public",
    children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
      language: language,
      publicId: publicId
    }), /*#__PURE__*/_jsxs(NavMarker, {
      name: "ACHIEVEMENT_LOADED",
      children: [/*#__PURE__*/_jsx("div", {
        className: "container-fluid",
        style: {
          backgroundColor: OLAF
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "container p-x-0",
          children: /*#__PURE__*/_jsx(CertificateHeader, {
            inModal: inModal,
            language: language,
            trackEvent: trackEvent
          })
        })
      }), /*#__PURE__*/_jsx(ColorCirclesHeader, {
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsx(AchievementUserProfile, {
            publicId: publicId
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "container-fluid",
        style: {
          backgroundColor: KOALA
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsxs("div", {
            className: "row",
            children: [/*#__PURE__*/_jsx("div", {
              className: "col-xs-12 col-md-6 p-x-0",
              children: /*#__PURE__*/_jsx(CertImageWrapper, {
                inModal: inModal,
                language: language,
                publicId: publicId,
                trackEvent: trackEvent
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "col-xs-12 col-md-6",
              children: /*#__PURE__*/_jsx(CurriculumInfo, {
                language: language,
                publicId: publicId
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(FooterBar, {
        bgColor: SLINKY,
        className: !inModal ? 'expand-down' : '',
        children: [/*#__PURE__*/_jsx(AcademyInfoFooter, {
          inModal: inModal
        }), !inModal && /*#__PURE__*/_jsx(FooterCTA, {
          language: language,
          publicId: publicId,
          trackEvent: trackEvent
        })]
      })]
    })]
  });
};